import { CategoryService } from './../../../services/category-service';
import { Component, OnInit } from '@angular/core';
import { Category } from '../../../models/category';
import * as siteSource from 'src/app/site/sitesource';
import { environment } from '../../../../environments/environment';
@Component({
  selector: 'app-blogs',
  templateUrl: './blogs.component.html',
  styleUrls: ['./blogs.component.scss']
})
export class BlogsComponent implements OnInit {

  categories:Category[];
  selectedCategory:Category=new Category();
  apiurl:string;
  constructor(private categoryService:CategoryService) {
   siteSource.showLoading();

    this.apiurl=environment.appUrl;
    this.categoryService.getSiteCategories().subscribe((res)=>{
      this.categories=res;
    if(window.localStorage.getItem("selectedBlogCategory"))
      {
          let selectedId=parseInt(window.localStorage.getItem("selectedBlogCategory"));
          if(this.categories.filter((f)=>f.id==selectedId)[0])
            this.selectedCategory=this.categories.filter((f)=>f.id==selectedId)[0];
            else
            this.selectedCategory=res[0]
      }
      else
    this.selectedCategory=res[0];
      setTimeout(() => {
   siteSource.hideLoading();
      }, 500);
    })
  }

  ngOnInit() {
  }
  changeCategory(id){
    this.selectedCategory=this.categories.filter(f=>f.id==id)[0];
    window.localStorage.setItem("selectedBlogCategory",id);
  }
}
